/*eslint-disable*/
// @ts-nocheck
import type { LoginBoxProps } from 'src/@types'
import { useRef, createElement, useEffect } from 'react'
import { Form, type FormInstance, Checkbox } from 'antd'
import clsx from 'clsx'
import { Input, Button } from 'src/component'
import { WxQrCode } from '../wxQrCode'
import { I18NS, INPUT_TYPE } from 'src/utils'
import { getFormStructure, useLoginUtils } from './login.utils'
import { ReactComponent as UpgradeSvg } from 'src/static/upgrade.svg'
import s from './login.module.scss'

const { Icon } = livecloud.icons

// 登陆类型
const enum TAB_TYPE {
  ACCOUNT = 1,
  EMAIL = 2,
  PHONE = 3,
  WX = 4,
}

function getTabTitle({ type, i18nKey }) {
  if (type == TAB_TYPE.ACCOUNT) return I18NS.ACCOUNT_LOGIN_WORD
  else if (type == TAB_TYPE.EMAIL) return I18NS.EMAIL_LOGIN_WORD
  else if (type == TAB_TYPE.PHONE) return I18NS.PHONE_LOGIN_WORD
  else if (type == TAB_TYPE.WX) {
    return I18NS.i18ns[i18nKey]
  }
  else return ''
}

export type LoginBoxState = {
  /** 当前选中的tab */
  tabType: string,
  /** 表单结构 */
  formStructure: any[],
  /* 是否是移动端 */
  isApp: Boolean
}

export function LoginBox({ initState, requestData, setRootState, getRootState, isApp, LanguageComponent }: LoginBoxProps) {
  const {
    loginConfig, openImgVerify, forgotPasswordEnabled,
    // 企业微信配置项
    workWXEnabled, workWXScanUrl,
    // 微信配置项
    weChatEnabled, weChatScanUrl,
    // 免密登录配置项
    bintangEnable, bintangDay,
    // 默认勾选七天内免登录
    bintangDefaultCheck,
    // 微信用户名称
    weChatUser,
    // 盐巴过期时间
    pwdSaltExpireIn,
    // 微信二维码配置项
    weChatIframe
  } = requestData


  const formRef = useRef<FormInstance>()
  // 盐巴过期时间
  const initialTime = Math.floor(parseFloat(pwdSaltExpireIn) / 1000)

  const [state, setState, getNewState] = livecloud.useStates(() => ({
    tabType: loginConfig[0].type,
    formStructure: getFormStructure(loginConfig[0].type),
    /** 是否开启免登录 */
    isBintang: bintangDefaultCheck ?? false,
    // 盐巴刷新时间
    time: initialTime
  }))

  const {
    login,
    toggleTab,
    workWeChatLogin,
    handleIsBintang,
    weChatLogin
  } = useLoginUtils({ setState, getNewState, setRootState, getRootState, formRef })
  const { tabType, formStructure, isBintang, time } = state

  const { lang } = getRootState()

  const startCountdown = () => {
    // 设置新的倒计时时间
    setState('time', initialTime)
  }

  useEffect(() => {
    if (time >= 0) {
      const interval = setInterval(() => {
        setState('time', prevTime => {
          if (prevTime <= 0) {
            clearInterval(interval)
            initState()
            startCountdown()
            return 0
          }
          return prevTime - 1
        })
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [initialTime, time])

  useEffect(() => {
    if (!time) {
      setState('time', initialTime)
    }
    if (!tabType && !formStructure) {
      setState({
        tabType: loginConfig[0].type,
        formStructure: getFormStructure(loginConfig[0].type)
      })
    }

  }, [formStructure, tabType, time])

  //是否绑定登录
  const isBindLogin = window.location.href.includes('&pageType=bindingLogin')

  const content =  (
    <>
      {
        isBindLogin && <div className={s.wxLoginBox}>{I18NS.WX_ACCOUNT_DESC}：<span>{weChatUser?.nickname}</span></div>
      }
      {
        tabType === TAB_TYPE.WX ? (
          <div className={`${s.wxLogin} b-fx b-j-c b-fx-col`}>
            {/* <UpgradeSvg />
            <p>{I18NS.SYSTEM_CONSTRUCTION}</p> */}
            <WxQrCode
              className={s.wxQrCode}
              config={weChatIframe}
            />
          </div>
        ) :(
          <Form
        key={tabType}
        name='basic'
        className={`${s.form} loginBox b-fx b-fx-col`}
        ref={formRef}
        autoComplete='off'
        onFinish={login}
      >
        {
          formStructure?.map(t => {
            const input = createElement(Input, t)
            return (
              t.type == INPUT_TYPE.IMG_VERIFY ? (
                openImgVerify ? input : null
              ) : input
            )
          })
        }
        <Button className='loginBtn' onClick={login}>
          {isBindLogin ? I18NS.BIND_LOGIN : I18NS.LOGIN_BTN_WORD}
        </Button>
      </Form>
        )
      }
      {
        isBindLogin ?
          <div className={`${s.wxLoginInfoArea} loginBottom b-fx b-j-sb`} >
            <div className={s.wxLoginInfo}>
              {I18NS.WX_ACCOUNT_TIP}
            </div>
          </div>
          :
          <>
            {
              !isApp ? (
                <div className={`${s.bottom} loginBottom b-fx b-j-sb`} >
                  <div
                    className={clsx(`${s.workWX} workWX b-fx`)}
                    style={{ paddingLeft: bintangEnable ? 0 : 'var(--padding)' }}
                  >
                    {
                      bintangEnable &&
                      <Checkbox className={`b-ellipsis ${s.bintang}`} checked={isBintang} onChange={handleIsBintang}>
                        {bintangDay}{I18NS.BINTANG_WORD}
                      </Checkbox>
                    }
                    <div
                      className={clsx(`${s.workWXIcon} workWXIcon b-fx`, workWXEnabled || s.hideWx)}
                      onClick={() => workWeChatLogin(workWXScanUrl)}
                    >
                      <Icon href='#LiveCloud-common-qiwei' size={16} />
                      <span>{I18NS.WORK_WX_LOGIN_WORD}</span>
                    </div>
                    <div
                      className={clsx(`${s.wxIcon} workWXIcon b-fx`, weChatEnabled || s.hideWx)}
                      onClick={() => weChatLogin(weChatScanUrl)}
                    >
                      <Icon href='#LiveCloud-yytj-weixin' size={16} />
                      <span>{I18NS.WX_LOGIN}</span>
                    </div>
                  </div>
                  {
                    forgotPasswordEnabled && (
                      <div className={`${s.forgetPassword} forgetPassword  b-fx`}>
                        <span onClick={() => setRootState('isForgetPassword', true)}>
                          {I18NS.FORGET_PASSWORD_WORD}
                        </span>
                      </div>
                    )
                  }
                </div>
              )
                :
                (
                  lang === 'en' ?
                    <div className={`${s.bottom} loginBottom`} style={{ height: 65 }}>
                      <div
                        className={`${s.forgetPassword} appLoginBottom b-fx b-j-sb`}
                        style={{ width: isApp ? '100%' : 'auto' }}
                      >
                        <div className='appLangSwitch b-fx'>
                          {
                            bintangEnable &&
                            <Checkbox checked={isBintang} className='b-ellipsis' onChange={handleIsBintang}>
                              {bintangDay}{I18NS.BINTANG_WORD}
                            </Checkbox>
                          }
                        </div>
                        {
                          forgotPasswordEnabled && (
                            <span className='b-ellipsis' appPassForget onClick={() => setRootState('isForgetPassword', true)}>
                              {I18NS.FORGET_PASSWORD_WORD}
                            </span>
                          )
                        }
                      </div>
                      <div className={`b-fx ${s.mobileLanguage}`}>
                        <LanguageComponent />
                      </div>
                    </div>
                    :
                    <div className={`${s.bottom} loginBottom b-j-sb`}>
                      <div
                        className={`${s.forgetPassword} appLoginBottom b-fx`}
                        style={{ width: isApp ? '100%' : 'auto' }}
                      >
                        <div className='appLangSwitch b-fx'>
                          {
                            bintangEnable &&
                            <Checkbox checked={isBintang} onChange={handleIsBintang}>
                              {bintangDay}{I18NS.BINTANG_WORD}
                            </Checkbox>
                          }
                          <LanguageComponent />
                        </div>
                        {
                          forgotPasswordEnabled && (
                            <span appPassForget onClick={() => setRootState('isForgetPassword', true)}>
                              {I18NS.FORGET_PASSWORD_WORD}
                            </span>
                          )
                        }
                      </div>
                    </div>
                )
            }
          </>
      }
      {
        time <= 15 && time !== 0 &&
        <div className={s.mark}>
          <div>
            {`${I18NS.TIME_DESC}`.replace('{0}', time)}
          </div>
          <div
            onClick={() => {
              initState()
              setState('time', 0)
            }}
          >
            {I18NS.NOW_DESC}
          </div>
        </div>
      }
    </>
  )

  return (
    <>
      <div className={`${s.tab} loginModes b-fx b-j-c`}>
        {
          loginConfig.map(t => (
            isApp && t.type === TAB_TYPE.WX || (
              <div
                key={t.type}
                className={clsx(s.tabItem, t.type === tabType && s.tabActive)}
                onClick={() => toggleTab(t.type)}
              >
                {getTabTitle(t)}
              </div>
            )
          ))
        }
      </div>
      {content}
    </>
  )
}
